import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Confetti from 'react-confetti';
import sizeMe from 'react-sizeme';
import Card from 'material-ui/Card';
import Grid from 'material-ui/Grid';
import IconButton from 'material-ui/IconButton';
import Button from '../../components/Buttons';
import CloseIcon from 'material-ui-icons/Close';
import Dialog from 'material-ui/Dialog';
import Slide from 'material-ui/transitions/Slide';
import missionCompleteBottomImgSrc from '../../assets/images/components/notification_mission_complete_bottom.png';
import missionCompleteImgSrc from '../../assets/images/ProgressLevels/mission_accomplished_medal.png';
import './Notification.css';

function Transition (props) {
    return <Slide direction="up" {...props} />;
}

class AchievementDialog extends Component  {
    static propTypes = {
        isOpen: PropTypes.bool.isRequired,
        dialogCloseHandler: PropTypes.func.isRequired,
        userLevel: PropTypes.number,
        isAccomplished: PropTypes.bool,
        isRenderHelpInfo: PropTypes.bool,
        readBooksNum: PropTypes.number,
        personalBookNum: PropTypes.number,
        showPersonalError: PropTypes.bool,
        showSeriesError: PropTypes.bool,
        showPrcBookError: PropTypes.bool,
        levelName: PropTypes.string,
        levelImage: PropTypes.string,
        accessibilityImgName: PropTypes.string,
    };

    renderAccomplishConfetti = () => {
        const {
            size,
            personalBookNum,
            readBooksNum
        } = this.props
        return  <div className="notification--accomplished">
                    <img src={missionCompleteImgSrc}
                         width={95}
                         height={110}
                         alt="mission_complete_top_img"/>
                    <p className="notification--accomplished--info">
                        Yay! You have completed the challenge by reading {readBooksNum - (personalBookNum? personalBookNum : 0)} PRC books
                        {personalBookNum ? ` and ${personalBookNum} Choice books!` : '!'}
                    </p>
                    <p className="notification--accomplished--info">
                        I hope you had a wonderful time reading these books, it will be sad to see you go.
                        However, you can still continue to read for leisure and pleasure as you have now unlocked
                        the Bonus Levels!
                    </p>
                    <img src={missionCompleteBottomImgSrc} width={180} height={68} alt="firework_bottom_img"/>
                </div>
    }

    renderHelpInfo = () => {
        return  <div className="notification__dialog__error ">
                    <p className="notification__dialog--title">Wrong School Listed?</p>
                    <p className="notification__dialog--info">
                        If the school listed is not the one you are currently enrolled in,
                        please contact your teacher or the PRC Administrator
                    </p>
                </div>
    }

    renderErrorDialog = () => {
        return  <div className="notification__dialog__error ">
                    <p className="notification__dialog--title">
                        {this.props.showPersonalError?
                            'Oops! Only 10 Personal Choice books allowed' :
                            'Oops! Only 5 books allowed from a series'}
                    </p>
                    <div className="notification__dialog--info">
                        {this.props.showPersonalError?
                            <div>
                                <p>Nice, you seem to be adding lots of Personal Choice books.
                                    However, the challenge allows only for 10 Personal Choice books.</p>
                                <p>Give the PRC list a go, we have so many exciting books for you.
                                    So go on, discover PRC books from the home page!</p>
                            </div>
                            :   <div>
                                <p>Well done, you must like this series a lot!</p>
                                <p>As much as I'd like to allow you to add this book to your Reading Log,
                                    the rules don't allow for it unfortunately.
                                </p>
                                <p>You can add this to your Personal Choice books list! Just head to your profile
                                    and choose 'Add a Personal Choice book'.
                                </p>
                            </div>}
                    </div>
                </div>
    }

    renderPrcBookError = () => {
        return  <div className="notification__dialog__error ">
                    <p className="notification__dialog--title">
                            Already added that!
                    </p>
                    <div className="notification__dialog--info notification__dialog--prcBookError">
                            <div>
                                <p>This book is already in your Reading Log.</p>
                            </div>
                    </div>
                </div>
    }

    renderDialogContent = () => {
        const {
            showPersonalError,
            showSeriesError,
            showPrcBookError,
            isAccomplished,
            isRenderHelpInfo,
            levelName,
            levelImage,
            accessibilityImgName,
        } = this.props;
        if (showPrcBookError) {
            return this.renderPrcBookError()
        } else if (showPersonalError || showSeriesError) {
            return this.renderErrorDialog()
        } else if (isAccomplished) {
            return this.renderAccomplishConfetti()

        } else if(isRenderHelpInfo){
            return this.renderHelpInfo()
            // render level up pop-up
        } else {
            return  <div>
                        <p className="notification__dialog--title">Level Up !</p>
                        <img src={levelImage}
                             width={140}
                             height={140}
                             alt={accessibilityImgName}/>
                        <div className="notification__dialog--info">
                            <p>You are now a</p>
                            <h2>{levelName}</h2>
                        </div>
                    </div>
        }
    }

    render() {
        const {
            isOpen,
            dialogCloseHandler
        } = this.props;
        return (
            <Dialog
                maxWidth="md"
                open={isOpen}
                onClose={dialogCloseHandler}
                transition={Transition}>
                <div className="notification__dialog">
                    <Grid item xs={12}>
                        <Card>
                            <div className="notification__dialog--iconButton">
                                <IconButton color="default"
                                            onClick={dialogCloseHandler}
                                            aria-label="Close">
                                    <CloseIcon />
                                </IconButton>
                            </div>
                            <div className="notification__dialog--content">
                                {this.renderDialogContent()}
                            </div>
                            <div className="notification__dialog--footer">
                                <Button onClick={dialogCloseHandler}>
                                    Continue
                                </Button>
                            </div>
                        </Card>
                    </Grid>
                </div>
            </Dialog>
        );
    }
}

export default sizeMe()(AchievementDialog);
